module.exports = __webpack_public_path__ + "f728e0a2a71339b465407f9e704b326d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/google_2023_chart.png
// module id = 1683
// module chunks = 0